import { useEffect, useState } from 'react';
import api from '../services/api';

const useRoles = () => {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (localStorage.getItem("access_token")) {
        const fetchRoles = async () => {
            try {
            const res = await api.get("/roles/my"); // Эндпоинт для получения данных пользователя
            setRoles(res.data);
            } catch (err) {
            console.error(err);
            }
        };
        fetchRoles();
    }
  }, []);

  const hasRole = (role) => roles.includes(role);
  return { roles, hasRole };
};

export default useRoles;